module.exports = __webpack_public_path__ + "static/media/kv-en.77b9f2cb.jpg";